<template>
  <form class="needs-validation ml-0" @submit.prevent="checkout" novalidate>
    <div class="col px-0 pr-lg-3">
      <div role="alert" class="alert alert-warning" v-if="saveErrorMessage">{{ saveErrorMessage }}</div>
      <div role="alert" class="alert alert-warning" v-if="checkoutErrorMessage">{{ checkoutErrorMessage }}</div>
      <div role="alert" class="alert alert-success" v-if="saveSuccessMessage">{{ saveSuccessMessage }}</div>
      <section class="bg-white rounded mb-4 p-3 p-sm-4" v-for="(memberDetail, index) in horsePages" :key="index">
        <div class="d-flex justify-content-between align-items-start" v-if="index === 0">
          <h1 class="h2 mb-3">{{ nominate === 'rookie' ? 'Nominate Horses For Rookie Status' : 'Register Horses'}}</h1>
        </div>
        <div role="alert" class="alert alert-warning" v-if="errors[index]">{{ errors[index] }}</div>
        <div role="alert" class="alert alert-warning" v-if="commonError">{{ commonError }}</div>
        <div class="row">
          <div class="col-12 col-md-6 form-group row no-gutters pr-xl-4">
            <label :for="'horseName' + index">Horse Name <span class="text-danger">*</span></label>
            <input 
              type="text" 
              :class="['form-control', errorStatus === 'name' && errors[index] ? 'is-invalid' : '']" 
              :id="'horseName' + index" 
              required 
              v-model="horseDetails[index].name"
            >
            <div class="invalid-tooltip">Please include the Horse Name.</div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label :for="'horseDob' + index">Date of Birth <span class="text-danger">*</span></label>
            <input 
              type="date" 
              :class="['form-control form-date', errorStatus === 'validation_error' && errors[index] ? 'is-invalid' : '']" 
              :id="'horseDob' + index" 
              required 
              v-model="horseDetails[index].dob" 
              :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" 
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
            >
            <div class="invalid-tooltip">Please include the Date of Birth of the horse{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="horseSex">Sex <span class="text-danger">*</span></label>
            <select 
              v-model="horseDetails[index].gender" 
              required 
              name="horseSex" 
              id="horseSex" 
              :class="['form-control', errorStatus === 'gender' && errors[index] ? 'is-invalid' : '']"
            >
              <option default></option>
              <option value="Mare">Mare</option>
              <option value="Gelding">Gelding</option>
              <option value="Stallion">Stallion</option>
            </select>
            <div class="invalid-tooltip">Please choose a gender.</div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="horseOwner">Owner <span class="text-danger">*</span></label>
            <div class="not-required">
              <member-search-select
                :element-id="'horseOwner' + index"
                context="owner"
                :value="horseDetails[index].owner_id || []"
                @input="v => $set(horseDetails[index], 'owner_id', v)"
              />
            </div>
            <div class="invalid-tooltip" :style="isOwnerInvalid(index) ? 'display: block': ''">Please include the Owner of the horse.</div>
            <small>Maximum of one owner</small>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label :for="'horseMembers' + index">Rider/s <span class="text-danger">*</span></label>
            <member-search-select
              :element-id="'horseMembers' + index"
              context="owner"
              multiple
              :limit="10"
              :value="horseDetails[index].selectedMembers || []"
              @input="v => $set(horseDetails[index], 'selectedMembers', v)"
            />
            <div class="invalid-tooltip" :style="isMemberInvalid(index) ? 'display: block': ''">Please include the Rider/s.</div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="status">Status</label>
            <select 
              :class="['form-control', errorStatus === 'horse_status_id' && errors[index] ? 'is-invalid' : '']" 
              id="status" 
              :disabled="userIsNotAdmin"
              v-model="horseDetails[index].horse_status_id"
            >
              <option v-for="(status, index) in $store.state.horseStatus" :value="status.id" :key="index">{{status.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include the Status.</div>
            <small v-if="userIsNotAdmin">If you need to update your horses status please contact the ACA office in business hours</small>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="boyStatus">Beginning of Year Status <span class="text-danger">*</span></label>
            <select 
              :class="['form-control', errorStatus === 'boy_status_id' && errors[index] ? 'is-invalid' : '']" 
              id="boyStatus" 
              required
              :disabled="userIsNotAdmin"
              v-model="horseDetails[index].boy_status_id"
            >
              <option disabled :selected="!horseDetails[index].boy_status_id"></option>
              <option v-for="(status, statusIndex) in $store.state.horseStatus" :key="statusIndex" :value="status.id" :selected="horseDetails[index].boy_status_id === status.id">{{status.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include the Rider Status.</div>
            <small v-if="userIsNotAdmin">If you need to update your horses status please contact the ACA office in business hours</small>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-block-mob btn-outline-primary px-lg-5" @click.prevent="horseDetails.splice(index,1);horsePages--" v-if="horsePages > 1">Remove</button>
          </div>
        </div>
      </section>

      <div class="d-lg-none bg-white rounded mb-4 p-3 p-sm-4 border-top border-light flex-grow-1">
        <h2 class="h4 mb-4">Save horses data</h2>
        <button :class="['btn btn-block mb-2', processing.save ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="saveHorsesData()">
          {{ !processing.save ? 'Save' : '' }}
          <div v-if="processing.save" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
        </button>
      </div>

      <div class="d-lg-none bg-white rounded mb-4 p-3 p-sm-4 border-top border-light flex-grow-1">
        <h2 class="h4 mb-4">Cart</h2>
        <h3 class="h6 mb-4">Horses ready for Check Out:</h3>
        <table class="table table-borderless">
          <tbody>
            <tr v-for="(type, typeKey, typeIndex) in horseList" :key="typeIndex">
              <td class="pl-0">{{typeKey}}</td>
              <td align="center">{{type}}</td>
              <td class="pr-0" align="right">${{(horseListPrice(nominate || 'register') * type).toFixed(2)}}</td>
            </tr>
          </tbody>
        </table>
        <small v-if="disableCheckOut" class="d-block mb-2" style="color: var(--black) !important"><strong>Please save your changes before checking out.</strong></small>
        <button :class="['btn btn-block mb-2', processing.checkOut ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit" :disabled="errorStatus !== '' || errors.length !== 0 || disableCheckOut">
          {{ !processing.checkOut ? 'Check Out' : '' }}
          <div v-if="processing.checkOut" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
        </button>
        <div class="d-flex justify-content-between align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.4 39.6" width="25" height="16" aria-labelledby="mastercard"><title id="mastercard">Mastercard</title><circle cx="19.5" cy="19.7" r="19" fill="#ee0005"/><circle cx="43" cy="19.7" r="19" fill="#f9a000"/><path fill="#ff6300" d="M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 153" width="35" height="11" aria-labelledby="visa"><title id="visa">Visa</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><path fill="#3c58bf" d="M185.3 149L210.9 5h40l-24.8 144z"/><path fill="#293688" d="M185.3 149L218.1 5h32.8l-24.8 144z"/><path fill="#3c58bf" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#293688" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#3c58bf" d="M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#293688" d="M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#3c58bf" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"/><path fill="#293688" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"/><path fill="#ffbc00" d="M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"/><path fill="#f7981d" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"/><path fill="#ed7c00" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"/><g fill="#051244"><path d="M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"/></g></g></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12" width="26" height="18" aria-labelledby="claimoucher"><title id="claimoucher">Claim Voucher</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"/><path fill="#231815" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="#231815" d="M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"/><g><path fill="#231815" d="M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"/></g></g></g></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" width="22" height="27" aria-labelledby="banktransfer"><title id="banktransfer">Bank Transfer</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"/><path fill="#231815" d="M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"/><g><path fill="#231815" d="M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"/></g></g></g></svg>
        </div>
      </div>
    </div>

    <desktop-action-bar>
      <div>
        <h2 class="h4 mb-4">Save horses data</h2>
          <button :class="['btn btn-block mb-2', processing.save ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="saveHorsesData()">
            {{ !processing.save ? 'Save' : '' }}
            <div v-if="processing.save" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </div>
        <div class="mt-4">
          <h2 class="h4 mb-4">Cart</h2>
          <h3 class="h6 mb-4">Horses ready for Check Out:</h3>
          <table class="table table-borderless">
            <tbody>
              <tr v-for="(type, typeKey, typeIndex) in horseList" :key="typeIndex">
                <td class="pl-0">{{typeKey}}</td>
                <td align="center">{{type}}</td>
                <td class="pr-0" align="right">${{(horseListPrice(nominate || 'register') * type).toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
          <small v-if="disableCheckOut" class="d-block mb-2" style="color: var(--black) !important"><strong>Please save your changes before checking out.</strong></small>
          <button
            :class="['btn btn-block mb-2', processing.checkOut ? 'btn-primary-dark' : 'btn-primary']"
            type="submit"
            @click="handleSubmit"
            :disabled="errorStatus !== '' || errors.length !== 0 || disableCheckOut"
          >
            {{ !processing.checkOut ? 'Check Out' : '' }}
          <div v-if="processing.checkOut" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
          <div class="d-flex justify-content-between align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.4 39.6" width="25" height="16" aria-labelledby="mastercard"><title id="mastercard">Mastercard</title><circle cx="19.5" cy="19.7" r="19" fill="#ee0005"/><circle cx="43" cy="19.7" r="19" fill="#f9a000"/><path fill="#ff6300" d="M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 153" width="35" height="11" aria-labelledby="visa"><title id="visa">Visa</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><path fill="#3c58bf" d="M185.3 149L210.9 5h40l-24.8 144z"/><path fill="#293688" d="M185.3 149L218.1 5h32.8l-24.8 144z"/><path fill="#3c58bf" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#293688" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#3c58bf" d="M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#293688" d="M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#3c58bf" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"/><path fill="#293688" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"/><path fill="#ffbc00" d="M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"/><path fill="#f7981d" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"/><path fill="#ed7c00" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"/><g fill="#051244"><path d="M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"/></g></g></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12" width="26" height="18" aria-labelledby="claimoucher"><title id="claimoucher">Claim Voucher</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"/><path fill="#231815" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="#231815" d="M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"/><g><path fill="#231815" d="M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"/></g></g></g></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" width="22" height="27" aria-labelledby="banktransfer"><title id="banktransfer">Bank Transfer</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"/><path fill="#231815" d="M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"/><g><path fill="#231815" d="M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"/></g></g></g></svg>
          </div>
        </div>
      </div>
    </desktop-action-bar>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import DesktopActionBar from '@/components/DesktopActionBar'
import MemberSearchSelect from '@/components/Members/MemberSearchSelect'

export default {
  name: 'HorseRegisterConfirm',
  props: ['nominate'],
  mixins: [HANDLESUBMIT, LEGACYBROWSERS],
  components: {
    'member-search-select': MemberSearchSelect,
    DesktopActionBar
  },
  data() {
    return {
      horsePages: 1,
      horseDetails: [{ gender: 'Mare' }],
      initialHorseDetails: [],
      horseDetailsHasData: false,
      processing: { save: false, checkOut: false },
      errorStatus: '',
      errors: [],
      commonError: '',
      disableCheckOut: false,
      saveSuccessMessage: '',
      checkoutErrorMessage: '',
      user: localStorage.role,
      userIsNotAdmin: false,
      saveErrorMessage: '',
      year: new Date(this.$store.state.currentDate).getFullYear() > 2023 ? new Date(this.$store.state.currentDate).getFullYear() : 2022
    }
  },
  watch: {
    horseDetails: {
      /* Count number of each type selected */
      handler(horseDetails) {
        this.checkValidity()
        this.initialHorseDetails.forEach((row, index) => {
          if (!horseDetails[index]) {
            return
          }
          Object.keys(row).forEach((field) => {
            if (field === 'members') {
              return
            }
            if (JSON.stringify(row[field]) !== JSON.stringify(horseDetails[index][field])) {
              this.disableCheckOut = true
            }
          })
        })
      },
      deep: true
    }
  },
  methods: {
    isOwnerInvalid(index) {
      if (this.wasValidated) {
        if (this.horseDetails[index].owner_id === undefined) {
          this.disableCheckOut = true
          return true
        } else if (this.horseDetails[index].owner_id.length === 0) {
          this.disableCheckOut = true
          return true
        }
      }
      return false
    },
    isMemberInvalid(index) {
      if (this.wasValidated) {
        if (this.horseDetails[index].selectedMembers === undefined) {
          this.disableCheckOut = true
          return true
        } else if (this.horseDetails[index].selectedMembers.length === 0) {
          this.disableCheckOut = true
          return true
        }
      }
      return false
    },
    horseListPrice(productType) {
      const filtered = this.$store.state.products.filter(product => product.sku === (productType === 'rookie' ? 'rookie-nomination' : 'horse-registration-'.concat(this.year)))
      return filtered.length > 0 ? Number(filtered[0].price) : 0
    },
    saveHorsesData() {
      this.processing.save = true
      this.checkValidity()
      const formData = new FormData()
      formData.append('fields', JSON.stringify({ horses: this.horseDetails, id: localStorage.userID }))

      axios.post(`${this.$api}/horse/update-horses`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          this.errors = []
          this.commonError = ''
          this.processing.save = false
          // eslint-disable-next-line
          // console.log(response)
          if (response.data.status === 'success') {
            if (response.data.updatedHorses.length > 0) {
              this.horseDetails = []
              response.data.updatedHorses.forEach((row) => {
                if (row !== null) {
                  row.owner_id = [row.owner_id.toString()]
                  this.horseDetails.push(row)
                }
              })
              this.horseDetails.forEach((horse, index) => {
                this.$set(this.horseDetails[index], 'selectedMembers', horse.members.map(a => a.id.toString()))
              })
              this.initialHorseDetails = JSON.parse(JSON.stringify(this.horseDetails))
            }
            this.saveErrorMessage = ''
            this.saveSuccessMessage = 'Horses data saved successfully.'
            setTimeout(() => { this.saveSuccessMessage = '' }, 3000)
            this.disableCheckOut = false
          } else if (response.data.errors && response.data.status === 'validation_error') {
            this.saveErrorMessage = 'Please fill in all fields'
          } else if (response.data.errors && response.data.status === 'verification_error') {
            this.saveErrorMessage = response.data.errors.message
          } else if (response.data.status === 'horse_limit') {
            this.commonError = response.data.message
          } else if (response.data.status === 'invalid_data') {
            this.commonError = response.data.message
          } else {
            this.errors.splice(0, 1, Object.entries(response.data.errors)[0][1][0])
          }
        })
    },
    checkout() {
      this.checkValidity()
      setTimeout(() => {
        if (this.formComplete === true) {
          this.processing.checkOut = true
          // eslint-disable-next-line
          axios.post(`${this.$api}/total-cart`, { data: this.horseDetails.map(horse => this.$store.state.products.filter(product => product.sku === (this.nominate === 'rookie' ? 'rookie-nomination' : 'horse-registration-'.concat(this.year)))[0].id) }).then((response) => {
            // eslint-disable-next-line
            // console.log(response.data)
            this.processing.checkOut = false
            if (response.data.status === 'success') {
              const horseData = response.data
              horseData.horses = this.horseDetails.map((item) => {
                const tempItem = item
                tempItem.owner_name = tempItem.owner_name
                return item
              })
              this.$store.commit('updateCartMembers', horseData)
              this.$router.push({ name: this.nominate === 'rookie' ? 'Nominate Rookie Cart' : 'Register Horse Cart', params: { nominate: this.nominate } })
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).some(k => k.indexOf("dob"))) { // Do any keys in the error object contain the text 'dob'?
              // DoB
              this.errorStatus = 'validation_error'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("dob"))[0].match(/\d+/)[0]] = `Please include the Date of Birth in the format${this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy'}.`
            }
          })
        } else {
          this.disableCheckOut = true
          this.checkoutErrorMessage = 'Please fill in all required fields before checking out.'
        }
      }, 10)
    }
  },
  computed: {
    horseList() {
      const list = this.horseDetails.reduce((horse, o) => {
        if (o.name) horse[o.name] = (horse[o.name] || 0) + 1
        return horse
      }, {})
      return list
    }
  },
  mounted() {
    if ((this.user !== 'Admin' && this.user !== 'SuperAdmin')) {
      this.userIsNotAdmin = true
    }
    /* Get horses to register */
    if (this.$store.state.selectedRows.length > 0) {
      this.horseDetails = []
      this.$store.state.selectedRows.forEach((row) => {
        row.owner_id = [row.owner_id.toString()]
        this.horseDetails.push(row)
      })
      this.horseDetails.forEach((horse, index) => {
        this.$set(this.horseDetails[index], 'selectedMembers', horse.members.map(a => a.id.toString()))
      })
      this.initialHorseDetails = JSON.parse(JSON.stringify(this.horseDetails))
      this.horsePages = this.$store.state.selectedRows.length
    } else {
      this.$router.push({ name: this.nominate === 'rookie' ? 'Nominate Rookie' : 'Register Horse' })
    }
  },
  beforeDestroy() {
    this.processing.checkOut = false
    this.processing.save = false
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Horses/Register/HorseRegisterConfirmDetails.vue